module.exports = __webpack_public_path__ + "img/mask.1e49083a.png";